/**
 * @desc 拦截订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/intercept`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
